import { Grid, Paper, styled } from '@mui/material';
import { Description, Forum } from '@mui/icons-material';
import { TFunction } from 'next-i18next';
import React from 'react'
import CustomButton from '../_shared/CustomButton';

const Resources = (props: Props) => {
	const { t } = props;

	const resources = [
		{
			icon: <Description color="primary" fontSize="large" />,
			title: t('presskit-h4'),
			description: t('presskit-p'),
			href: 'https://drive.google.com/drive/folders/1a5-xvB5Yl2H_tzWB-VBQ4Ffqu21SexID?usp=sharing',
			button_title: t('presskit-btn'),
			open_new_tab: true,
		},
		{
			icon: <Forum color="primary" fontSize="large" />,
			title: t('media-inq-h4'),
			description: t('media-inq-p'),
			href: '#press-contact-us',
			button_title: t('contact-h3'),
			open_new_tab: false,
		},
  ]
  
  return (
    <Grid item xs={12} md={4}>
			<h3 style={{ textAlign: 'left' }}>{t('resources-h3')}</h3>
      {
        resources?.map(resource => (
          <StyledPaper elevation={0} key={resource.title}>
            {resource.icon}
            <h3>{resource.title}</h3>
            <p>{resource.description}</p>
            <a href={resource.href} target={resource.open_new_tab ? "_blank" : "_self" }>
              <CustomButton>{resource.button_title}</CustomButton>
            </a>
          </StyledPaper>
        ))
      }
    </Grid>
  )
}

interface Props {
  t: TFunction
}

const StyledPaper = styled(Paper)(({ theme }) => ({
  borderRadius: '1rem',
	backgroundColor: theme.palette.primary.light,
	padding: '2rem 2rem 2.4rem',
	margin: '1rem 0 1.8rem'
}))

export default Resources
